<div class="row">
    <div class="col-md-12">
        <ax-panel title="Doenças Ativas">
            <div class="row">
                <div class="col-md-12">
                    <ejs-grid #gridAtivas
                    [dataSource]="registrosDoencasAtivas"

                    [enableVirtualization]='true'  height='200' 
                    [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings'
                    [allowFiltering]='true' 
                    [allowSorting]='true' 
                    [allowResizing]='true' 
                    
                    [toolbar]="toolbarDoencasAtivasItens"

                    [showColumnChooser]='true'
                    [showColumnMenu]='true'
                    [pageSettings]='{ pageSize: 100 }'
                    [allowExcelExport]='true'
                    [allowPdfExport]='true'
                    [allowPdfExport]='true'
                    >
                    <e-columns>
                        <e-column field='id' width='50' [headerText]="'Id'" [isPrimaryKey]="true" [visible]="true"></e-column>
                        <e-column field='cid10Id' width='50'  [headerText]="'CID10'" [visible]="true"></e-column>
                        <e-column field='cid10Texto' [headerText]="'Descrição'"></e-column>
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="id" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
                </div>
            </div>
        </ax-panel>
    </div>
    <div class="col-md-12">
        <ax-panel title="Doenças Inativas">
            <div class="row">
                <div class="col-md-12">
                    <ejs-grid #gridInativas
                    [dataSource]="registrosDoencasInativas"

                    [enableVirtualization]='true'  height='200' 
                    [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings'
                    [allowFiltering]='true' 
                    [allowSorting]='true' 
                    [allowResizing]='true' 

                    [toolbar]="toolbarDoencasInativasItens"

                    [showColumnChooser]='true'
                    [showColumnMenu]='true'
                    [pageSettings]='{ pageSize: 100 }'
                    [allowExcelExport]='true'
                    [allowPdfExport]='true'
                    [allowPdfExport]='true'
                    >
                    <e-columns>
                        <e-column field='id' width='50'  [headerText]="'Id'" [isPrimaryKey]="true" [visible]="true"></e-column>
                        <e-column field='cid10Id' [headerText]="'CID10'" [visible]="true"></e-column>
                        <e-column field='cid10Texto' [headerText]="'Descrição'"></e-column>
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="id" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
                </div>
            </div>
        </ax-panel>
    </div>
</div>